import { Input, Label, FormGroup } from 'reactstrap'
import React from 'react'
import useTranslation from '../hooks/UseTranslation'

const PasswordInput = (props) => {
  const { t } = useTranslation()
  const [msg1, setMsg1] = React.useState(null)
  const [msg2, setMsg2] = React.useState(null)
  const [password1, setPassword1] = React.useState('')
  const [password2, setPassword2] = React.useState('')
  const [confirm, setConfirm] = React.useState(props.confirm)

  React.useEffect(() => {
    setConfirm(props.confirm)
  }, [props.confirm])

  React.useEffect(() => {
    let valid = false
    if (password1) {
      const [msg1, msg2] = validatePassword(password1, password2)
      if (msg1 === true && (!confirm || msg2 === true)) {
        valid = true
        setMsg1(null)
        setMsg2(null)
      } else {
        setMsg1(msg1)
        setMsg2(msg2)
      }
    } else {
      setMsg1(null)
      setMsg2(null)
    }
    props.onChange(valid, password1)
  }, [password1, password2])

  const validatePassword = (password1, password2) => {
    if (!password1) return [null, null]
    if (password1.length < 8) return [t('password_at_least_not_strong'), null]
    if (!password2) return [true, null]
    if (password2 != password1) return [true, t('password_no_match')]
    return [true, true]
  }

  return (
    <>
      <FormGroup>
        <Label for='loginUsername' className='form-label'>
          {props.label1}
        </Label>
        <Input
          onChange={(e) => setPassword1(e.target.value)}
          name='newPassword'
          id='newPassword'
          type='password'
          autocomplete={props.autocomplete}
          placeholder={props.placeholder1}
          required
        />
        <small id='help' className='form-text text-muted'>
          {msg1 ?? ''}
        </small>
      </FormGroup>
      <FormGroup>
        {confirm && (
          <>
            <Label for='loginUsername' className='form-label'>
              {props.label2}
            </Label>
            <Input
              onChange={(e) => setPassword2(e.target.value)}
              name='newPassword'
              id='newPassword'
              type='password'
              placeholder={props.placeholder2}
              autoComplete='off'
              required
            />
            <small id='help' className='form-text text-muted'>
              {msg2 ?? ''}
            </small>{' '}
          </>
        )}
      </FormGroup>
    </>
  )
}

export default PasswordInput
